import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-notifications-component/dist/theme.css'
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Home from "./Pages/Home";
import Grassy from "./Pages/Grassy";

import Clubfitting from "./Pages/Clubfitting";
import Lesson from "./Pages/Lesson";
import { BrowserRouter } from "react-router-dom";
import { VideoProvider } from "./videoContext";
import Dashboard from "./Pages/Dashboard";
import CustomerProfile from "./Pages/CustomerProfile";
import IronFaitting from "./Pages/IronFaitting";
import { CustomerAdd, CustomerEdit } from "./Pages/CustomerEdit";
import Admin from "./DashboardPages/Admin/Admin";
import AddFitter from "./DashboardPages/Fitters/AddFitter";
import ListFitter from "./DashboardPages/Fitters/ListFitter";
import CustomerList from "./DashboardPages/Customer/CustomerList";
import RequestList from "./DashboardPages/Request/Request";
import RequestSingle from "./DashboardPages/Request/RequestSingle";
import IronFittingEdit from "./Pages/IronFittingEdit";
import Login from "./Pages/Login";
import CustomerDetails from "./DashboardPages/Customer/CustomerAdd";
import AddCustomer from "./DashboardPages/Customer/CustomerAdd";
import CustomerDetail from "./DashboardPages/Customer/CustomerDetails";
import EditCustomer from "./DashboardPages/Customer/CustomerEdit";
import Fitting from "./DashboardPages/Fitters/Fitting";
import AddFitting from "./DashboardPages/Fitters/AddFitter";
import FittingDetalis from "./DashboardPages/Fitters/FittingDetails";
import EditFitting from "./DashboardPages/Fitters/EditFitter";
import FollowUps from "./DashboardPages/FollowUps/FollowUps";
import FollowView from "./DashboardPages/FollowUps/FollowView";
import Staff from "./DashboardPages/Staff/Staff";
import StaffAdd from "./DashboardPages/Staff/StaffAdd";
import StaffView from "./DashboardPages/Staff/StaffView";
import StaffEdit from "./DashboardPages/Staff/StaffEdit";
import PrivateRoute from "./Routes/PrivateRoute";
import CompletBag from "./Components/CompletBag/CompletBag";
import GolfClub from "./Pages/GolfClub";
import GolfStore from "./Pages/GolfStore";
import ClubFollowUps from "./DashboardPages/ClubFollowUps/ClubFollowUps";
import ClubFollowView from "./DashboardPages/ClubFollowUps/ClubFollowView";
import ForewardFitting from "./DashboardPages/ForewardFitting/ForewardFitting";
import ForewardFitting2 from "./DashboardPages/ForewardFitting/ForewardFitting2";
import ForewardFitting3 from "./DashboardPages/ForewardFitting/ForewardFitting3";
import ForewardFitting4 from "./DashboardPages/ForewardFitting/ForewardFitting4";
import RemoteFittingNew from "./DashboardPages/ForewardFitting/RemoteFittingNew";
import RemoteFittingStudio from "./DashboardPages/ForewardFitting/RemoteFittingStudio";
import RemoteFitting2 from "./DashboardPages/ForewardFitting/RemoteFitting2";
import ClubfittingNew from "./DashboardPages/ClubfittingNew/ClubfittingNew";
import RemoteInquiries from "./DashboardPages/ForewardFitting/RemoteInquiries";
import FitterApplication from "./DashboardPages/ForewardFitting/FitterApplication";
import Orders from "./DashboardPages/ForewardFitting/Orders";
import FitterAccounts from "./DashboardPages/ForewardFitting/FitterAccounts";
import FitterLocator from "./DashboardPages/ForewardFitting/FitterLocator";
import FitterProfile from "./DashboardPages/ForewardFitting/FitterProfile";
import Remotekits from "./DashboardPages/ForewardFitting/Remotekits";
import RemoteInquiriesView from "./DashboardPages/ForewardFitting/RemoteInquiriesView";
import RemotekitView from "./DashboardPages/ForewardFitting/RemotekitView";
import NewFitting from "./DashboardPages/Fitters/NewFitting";
import { ForwardFittingProvider } from "./DashboardPages/ForewardFitting/ForwardFittingContext";
import { ClubFittingProvider } from "./DashboardPages/ClubfittingNew/ClubFittingContext";
import RemoteFittingFollowUps from "./DashboardPages/RemoteFittingFollowUps/RemoteFittingFollowUps";
import UserDashboard from "./UserDashboard/user_dashboard";
import Page404 from "./Pages/Page404";
import Paynow from "./Pages/Paynow";
import Events from "./DashboardPages/Events/Events";
import GrassyViews from "./DashboardPages/Events/GrassyViews";
import Arizona from "./Pages/Arizona";
import OlivasLinks from "./Pages/OlivasLinks";
import forgetpassword from "./Pages/forgetpassword";
import activeaccount from "./Pages/activeaccount";
import ClubFittingUpdate from "./DashboardPages/clubfittingupdate/ClubFittingUpdate";
import BuildSheet from "./DashboardPages/BuildSheet/BuildSheet";
import Projects from "./DashboardPages/Projects/Projects";
import ProjectView from "./DashboardPages/Projects/ProjectView";
import Prescription from "./DashboardPages/Prescription/Prescription";
import PrescriptionView from "./DashboardPages/Prescription/PrescriptionView";
import BuildStation from "./DashboardPages/BuildSheet/BuildStation";
import UnassignedBuildSheet from "./DashboardPages/BuildSheet/UnassignedBuildSheet";
import StagingStation from "./DashboardPages/BuildSheet/StagingStation";
import NewBuildSheet from "./DashboardPages/BuildSheet/NewBuildSheet";
import CurrentBuilds from "./DashboardPages/Projects/CurrentBuilds";
import VerifiedBuilds from "./DashboardPages/Projects/VerifiedBuilds";
import ShipStation from "./DashboardPages/BuildSheet/ShipStation";
import PickUpStation from "./DashboardPages/BuildSheet/PickUpStation";
import NewPrescription from "./DashboardPages/Prescription/NewPrescription";
import NewPrescription2 from "./DashboardPages/Prescription/NewPrescription2";
import StationList from "./DashboardPages/BuildSheet/BuildStation/StationList";
import StationView from "./DashboardPages/BuildSheet/BuildStation/StationView";
import StationAdd from "./DashboardPages/BuildSheet/BuildStation/StationAdd";
import StagestationList from "./DashboardPages/BuildSheet/StageStations/StationList";
import StagestationView from "./DashboardPages/BuildSheet/StageStations/StationView";
import stageStationAdd from "./DashboardPages/BuildSheet/StageStations/StationAdd";
import ShipStationList from "./DashboardPages/BuildSheet/ShipStations/StationList";
import ShipStationView from "./DashboardPages/BuildSheet/ShipStations/StationView";
import ShipStationAdd from "./DashboardPages/BuildSheet/ShipStations/StationAdd";
import Fitter from "./Fitter/Fitter";
import FitterBuilder from "./Fitter/FitterBuilder";
import Viewfitter from "./Fitter/Viewfitter";
import Viewreferral from "./Fitter/ViewReferral";
import viewfitterbuilder from "./Fitter/viewfitterbuilder";
import FitterProjectView from "./Fitter/FitterProjectView";
import UserProjectView from "./Fitter/UserProjectView";
import BuilderDashboard from "./Builder/BuilderDashboard";
import ViewBuilder from "./Builder/ViewBuilder";
import BuilderProjectView from "./Builder/BuilderProjectView";
import Inventory from "./DashboardPages/Inventory/Inventory";
import Camera from "./DashboardPages/Cemara/Camera";
import VideoUploader from "../src/VideoUploader"
import BuildsheetInsights from "./DashboardPages/BuildSheet/BuildsheetInsights";
import FitterBuilderOrder from "./Fitter/FitterBuilderOrder";
import FitterBuilderView from "./Fitter/FitterBuilderView";
import PartyKit from "./DashboardPages/ForewardFitting/PartyKit";
import PartyKitView from "./DashboardPages/ForewardFitting/PartyKitView";
import Referrals from "./DashboardPages/ForewardFitting/Referrals";
import ReferralView from "./DashboardPages/ForewardFitting/ReferralView";
import TroonAccess from "./Pages/TroonAccess";
import Stockdale from "./Pages/Stockdale";

function App() {
  return (
    <VideoProvider>
      <Router>
        <Switch>
          <div className="App">
            <Route exact path="/">
              <Redirect to="/club-fitting" />
            </Route>
            <Route exact path="/rates">
              <Redirect to="/about-us" />
            </Route>
            <Route exact path="/contact-us">
              <Redirect to="/about-us" />
            </Route>
            <Route exact path="/repair-1">
              <Redirect to="/about-us" />
            </Route>

            <Route exact path="/about-us" component={Home} />
            <Route exact path="/grassy" component={Grassy} />
            <Route exact path="/arizona" component={Arizona} />
            <Route exact path="/olivas" component={OlivasLinks} />
            <Route exact path="/troon" component={TroonAccess} />
            <Route exact path="/stockdale" component={Stockdale} />
            <Route exact path="/events" component={Events} />
            <Route exact path="/Grassy-views/:id" component={GrassyViews} />
            <Route exact path="/club-fitting" component={Clubfitting} />
            <Route exact path="/lessons" component={Lesson} />
            <Route exact path="/golf-clubs" component={GolfClub} />
            <Route exact path="/complet-bag" component={CompletBag} />
            <Route exact path="/golf_store" component={GolfStore} />
            <Route path="/fitter/fitter-locator" component={FitterLocator} />
            <Route path="/fitter/fitter-profile/:id" component={FitterProfile} />
            <PrivateRoute exact path="/fitter-dashboard" component={Fitter} />
            <PrivateRoute exact path="/fitter-builder-dashboard" component={FitterBuilder} />
            <PrivateRoute exact path="/fitter-builder-order/:id" component={FitterBuilderOrder} />
            <PrivateRoute exact path="/fitter-builder-view/:id" component={FitterBuilderView} />
            <PrivateRoute exact path="/fitter-project-view/:id" component={FitterProjectView} />
            <PrivateRoute exact path="/user-project-view/:id" component={UserProjectView} />
            {/* <Route exact path="/fitter_dashboard" component={Fitter} />
            <Route exact path="/fitter-project-view" component={FitterProjectView} /> */}
            <PrivateRoute exact path="/builder-dashboard" component={BuilderDashboard} />
            <PrivateRoute exact path="/builder-project-view/:id" component={BuilderProjectView} />
            <PrivateRoute exact path="/user-dashboard" component={UserDashboard} />
            <PrivateRoute exact path="/prescription-view/:id" component={PrescriptionView} />
            <PrivateRoute exact path="/dashboard" component={Projects} />
            <PrivateRoute exact path="/list-customer" component={CustomerList} />
            <PrivateRoute exact path="/fitter-customer" component={CustomerList} />
            <PrivateRoute path="/add-customer" component={AddCustomer} />
            <PrivateRoute path="/add-referral" component={ReferralView} />
            <PrivateRoute path="/customer-details/:id" component={CustomerDetail} />
            <PrivateRoute path="/edit-customer" component={EditCustomer} />
            <PrivateRoute path="/new-fitting" component={NewFitting} />
            <PrivateRoute path="/fitting" component={Fitting} />
            <PrivateRoute path="/list-fitting" component={ListFitter} />
            <PrivateRoute path="/add-fitting" component={AddFitting} />
            <PrivateRoute path="/fitting-view/:id" component={FittingDetalis} />
            <PrivateRoute path="/edit-fitting" component={EditFitting} />
            <PrivateRoute path="/staff" component={Staff} />
            <PrivateRoute path="/add-staff" component={StaffAdd} />
            <PrivateRoute path="/view-staff/:id" component={StaffView} />
            <PrivateRoute exact path="/view-fitter/:id" component={Viewfitter} />
            <PrivateRoute exact path="/view-referral/:id" component={Viewreferral} />
            <PrivateRoute exact path="/view-fitter-builder/:id" component={viewfitterbuilder} />
            <PrivateRoute exact path="/view-builder/:id" component={ViewBuilder} />
            <PrivateRoute path="/edit-staff/:id" component={StaffEdit} />
            <PrivateRoute path="/followups" component={FollowUps} />
            <PrivateRoute path="/remote_fitting_follow" component={RemoteFittingFollowUps} />
            <PrivateRoute path="/followview/:id" component={FollowView} />
            <PrivateRoute path="/ironFitting-edit/:id" component={IronFittingEdit} />
            <PrivateRoute path="/login" component={Login} />
            <PrivateRoute path="/club-followups" component={ClubFollowUps} />
            <PrivateRoute path="/club-follow-up-details/:id" component={ClubFollowView} />
            {/* <PrivateRoute path="/club-follow-up-details/:id" component={ClubFollowView} /> */}
            <PrivateRoute path="/pay-now" component={Paynow} />
            <Route path="/forgetpassword" component={forgetpassword} />
            <Route path="/activeaccount" component={activeaccount} />
            <ForwardFittingProvider >
              <PrivateRoute path="/remote_fitting" component={ForewardFitting} />
              <PrivateRoute path="/project-create" component={ForewardFitting} />
              <PrivateRoute path="/remote_inquirie" component={RemoteInquiries} />
              <PrivateRoute path="/fitter_application" component={FitterApplication} />
              <PrivateRoute path="/orders" component={Orders} />
              <PrivateRoute path="/fitter_accounts" component={FitterAccounts} />
              <PrivateRoute path="/remote_kits" component={Remotekits} />
              <PrivateRoute path="/referrals" component={Referrals} />
              <PrivateRoute path="/remote_inquirie_view/:id" component={RemoteInquiriesView} />
              <PrivateRoute path="/remote_kits_view/:id" component={RemotekitView} />
              <PrivateRoute path="/remote_fitting_user/:id" component={ForewardFitting2} />
              <PrivateRoute path="/project_create_user/:id" component={ForewardFitting3} />
              <PrivateRoute path="/project_camera_user/:id" component={ForewardFitting4} />
              {/* <PrivateRoute path="/remote_fittings_new" component={RemoteFittingNew} /> */}
              <PrivateRoute path="/remote_fittings_camera/:id" component={RemoteFittingNew} />
              <PrivateRoute path="/remote_fittings_studio/:id" component={RemoteFittingStudio} />
              <PrivateRoute path="/remote_fittings_camera2/:id" component={RemoteFitting2} />
            </ForwardFittingProvider>
            <ClubFittingProvider >
              <PrivateRoute path="/club_fitting/:id" component={ClubfittingNew} />
            </ClubFittingProvider>
            <PrivateRoute path="/all-projects" component={Projects} />
            <PrivateRoute exact path="/project/clubfitting" component={Projects} />
            <PrivateRoute exact path="/project/prescription" component={Projects} />
            <PrivateRoute exact path="/project/buildstation" component={Projects} />
            <PrivateRoute exact path="/project/buildsheet" component={Projects} />
            <PrivateRoute exact path="/project/staging-station" component={Projects} />
            <PrivateRoute exact path="/project/ship-station" component={Projects} />
            <PrivateRoute exact path="/project/pick-up-station" component={Projects} />

            <PrivateRoute exact path="/project/clubfitting/clubfitting-view/:id" component={ClubFittingUpdate} />
            <PrivateRoute exact path="/project/prescription/prescription-view/:id" component={Prescription} />
            <PrivateRoute exact path="/project/buildstation/buildstation-view/:id" component={BuildStation} />
            <PrivateRoute exact path="/project/ship-station/shipstation-view/:id" component={ShipStation} />
            <PrivateRoute exact path="/project/pickup-station/pickup-view/:id" component={PickUpStation} />
            <PrivateRoute exact path="/project/buildsheet/buildsheet-view/:id" component={UnassignedBuildSheet} />
            <PrivateRoute exact path="/project/buildsheet/buildsheet-insights/:id" component={BuildsheetInsights} />
            <PrivateRoute exact path="/project/staging-station/staging-station-view/:id" component={StagingStation} />
            <PrivateRoute path="/project/buildsheet/unassigned-build-view/:id" component={UnassignedBuildSheet} />
            <PrivateRoute path="/project/project-view/:id" component={ProjectView} />
            <PrivateRoute path="/new-build" component={NewBuildSheet} />
            <PrivateRoute path="/current-build" component={CurrentBuilds} />
            <PrivateRoute path="/verified-build" component={VerifiedBuilds} />
            <PrivateRoute path="/create-prescription" component={NewPrescription} />
            <PrivateRoute path="/create-buildsheet" component={BuildSheet} />
            <PrivateRoute path="/build-station-list" component={StationList} />
            <PrivateRoute path="/buildstation-view/:id" component={StationView} />
            <PrivateRoute path="/buildstation-add" component={StationAdd} />
            <PrivateRoute path="/stagestation-list" component={StagestationList} />
            <PrivateRoute path="/stagestation-view/:id" component={StagestationView} />
            <PrivateRoute path="/stagestation-add" component={stageStationAdd} />
            <PrivateRoute path="/shipstation-list" component={ShipStationList} />
            <PrivateRoute path="/shipstation-view/:id" component={ShipStationView} />
            <PrivateRoute path="/shipstation-add" component={ShipStationAdd} />
            <PrivateRoute path="/inventory" component={Inventory} />
            <PrivateRoute path="/camera" component={Camera} />

            <PrivateRoute path="/project/clubfitting/camera" component={NewPrescription2} />

            <PrivateRoute path="/localstorage" component={VideoUploader} />

            <PrivateRoute path="/party-kit" component={PartyKit} />

            <PrivateRoute path="/party-kit-view/:id" component={PartyKitView} />

            {/* <Route path="*" component={Page404} /> */}
          </div>
        </Switch>
      </Router>
    </VideoProvider>
  )
}

export default App;